import { useEffect } from "react";
import { cx } from "../../utils/classNames";
import ui from "./ui.module.css";

// Centered dialog (or a right-side drawer with `variant="drawer"`).
// Closes on Escape and on backdrop click.
const Modal = ({
  title,
  onClose,
  footer,
  variant = "modal",
  as: Container = "div",
  onSubmit,
  children,
}) => {
  useEffect(() => {
    const handleKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  const isDrawer = variant === "drawer";

  return (
    <div
      className={cx(ui.overlay, isDrawer && ui.overlayRight)}
      onClick={onClose}
    >
      <Container
        className={isDrawer ? ui.drawer : ui.modal}
        onClick={(e) => e.stopPropagation()}
        onSubmit={onSubmit}
        role="dialog"
        aria-modal="true"
      >
        <div className={ui.overlayHeader}>
          <h5 className={ui.overlayTitle}>{title}</h5>
          <button
            type="button"
            className={ui.iconButton}
            onClick={onClose}
            aria-label="Close"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {children}

        {footer && <div className={ui.overlayFooter}>{footer}</div>}
      </Container>
    </div>
  );
};

export default Modal;
